export const FETCH_EMPLOYEE_SALARY_DETAILS = "FETCH_EMPLOYEE_SALARY_DETAILS";
export const FETCH_ENTITLED_LEAVE_DETAILS = "FETCH_ENTITLED_LEAVE_DETAILS";
export const FETCH_EMPLOYEE_BASIC_DETAILS = "FETCH_EMPLOYEE_BASIC_DETAILS";
